module.exports = __webpack_public_path__ + "fonts/battery-charging-twotone-100_svgrepo.com.svg";